import { render } from "./heart.vue?vue&type=template&id=f00d9f16"
import script from "./heart.vue?vue&type=script&lang=js"
export * from "./heart.vue?vue&type=script&lang=js"
script.render = render

export default script